module.exports = __webpack_public_path__ + "static/dedicated_desk_2-d2ca3047ea1197982145e1bb1bf0eed0.webp";